import type { RouteComponentProps } from './RouteComponentProps';
import { withRouter } from './withRouter';

export type { RouteComponentProps };
export { withRouter };
